import { registerPlugin } from "@capacitor/core";

export interface NativePermissionResult {
  granted: boolean;
}

export interface AltenotPermissionsPlugin {
  requestLocation(): Promise<NativePermissionResult>;
  requestCamera(): Promise<NativePermissionResult>;
  openApplicationSettings(): Promise<void>;
}

const noopImpl = () => ({
  requestLocation: async () => ({ granted: true }),
  requestCamera: async () => ({ granted: true }),
  openApplicationSettings: async () => undefined,
});

export const AltenotPermissions = registerPlugin<AltenotPermissionsPlugin>(
  "AltenotPermissions",
  {
    web: noopImpl,
    ios: noopImpl,
  },
);
